import { api } from "./client";

export const MarkersAPI = {
  createClub: async (payloadV1) => {
    const { data } = await api.post("/api/v1/markers/club", payloadV1);
    return data;
  },

  createEvent: async (payload) => {
    const { data } = await api.post("/api/v1/markers/event", payload);
    return data;
  },

  getAllMarkers: async (params = {}) => {
    const { data } = await api.get("/api/v1/markers", { params });
    return data;
  },

  getMarker: async (id) => {
    const { data } = await api.get(`/api/v1/markers/${id}`);
    return data;
  },

  updateMarker: async (id, payload) => {
    const { data } = await api.put(`/api/v1/markers/${id}`, payload);
    return data;
  },

  deleteMarker: async (id) => {
    await api.delete(`/api/v1/markers/${id}`);
    return true;
  },

  approveMarker: async (id) => {
    await api.patch(`/api/v1/markers/${id}/approve`, {});
    return true;
  },

  unapproveMarker: async (id) => {
    await api.patch(`/api/v1/markers/${id}/unapprove`, {});
    return true;
  },

  getPendingByHostCode: async (code, page = 0, size = 50) => {
    const { data } = await api.post(
      '/api/v1/host-permissions/markers/pending',
      { code },
      { params: { page, size } }
    );
    return data;
  },

   uploadMarkersCsvBulk: async (file, { dryRun = false } = {}) => {
    const form = new FormData();
    form.append("file", file);
    form.append("dryRun", String(dryRun));

    const { data } = await api.post("/api/v1/markers/bulk", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
};
